import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {isInMwStep1TextVariation} from '~/CreateFabricInvitation/utils/experiments';
import {eventInEditMode} from '~/CreateFabricInvitation/reducers/details/selectors';
import {TextEditorVariant} from './ABTest/TextEditorVariant';
import {TextEditorControl} from './ABTest/TextEditorControl';

export const TextEditor = () => {
  const isDesktop = useIsLargishAndUp();
  const isInEditMode = useSelector(eventInEditMode);

  const isVariation = useMemo(
    () => (isDesktop ? false : isInMwStep1TextVariation(isInEditMode)),
    [isDesktop, isInEditMode]
  );

  return isVariation ? <TextEditorVariant /> : <TextEditorControl />;
};
